
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyB-QwlkNB5YnjKKINoUfqvAyS17z6QMzmk",
  authDomain: "crusade-cloud.firebaseapp.com",
  databaseURL: "https://crusade-cloud.firebaseio.com",
  projectId: "crusade-cloud",
  storageBucket: "crusade-cloud.appspot.com",
  messagingSenderId: "724209075612",
  appId: "1:724209075612:web:d7e1ab06f9ca4298ed3459",
  measurementId: "G-FXCNX0R8LT"
};
firebase.initializeApp(firebaseConfig)
const db = firebase.firestore();
const auth = firebase.auth()

// collection references
const usersCollection = db.collection('users')

// Utilities
const increment = firebase.firestore.FieldValue.increment(1)
const decrement = firebase.firestore.FieldValue.increment(-1)
const firebaseTimeNow = () => { return firebase.firestore.Timestamp.now() }

// export utils/refs
export {
  db,
  auth,
  usersCollection,
  decrement,
  increment,
  firebaseTimeNow
}





